module.exports = __webpack_public_path__ + "img/examine.70b662a8.png";